import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { ISeverity } from '@obvious.tech/constellation'

export const Severity = defineEntity('Severity', {
  endpoint: 'alarms/api/Severity',
  schema: SNoop<ISeverity>(),
})
